import { useState, useEffect } from "react";

import API from "utils/api";
import { useUser } from "utils/hooks";
import { anyToHash } from "utils/misc";

export default function useAdminPages(filters = {}) {
  const { token } = useUser();
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchPages() {
      setLoading(true);
      const { response, data } = await API.admin.fetchPages(token, filters);

      if (response.ok) {
        setResult(data);
      }

      setLoading(false);
    }

    fetchPages();
  }, [token, anyToHash(filters)]);

  return {
    loading,
    pages: result?.results ?? [],
    count: result?.count ?? 0,
    limit: result?.limit ?? 0,
    page: result?.page ?? 0,
  };
}
